module.exports = __webpack_public_path__ + "68ce87408b.svg";